import { Translate } from '~/i18n';

import { Region } from '../../home-page/cities-slider';
import { FilterCategory } from '~/interfaces/filters';

import { useState } from 'react';
import { AdvancedFiltersList } from './filters-list';
import BottomSheet from '~/components/common/bottom-sheet';
import { CloseIcon } from '~/svgs/common';
import Router, { useRouter } from 'next/router';
import { handleFilterCategoryChange, handleFilterItemChange } from './handlers';
import { BottomSheetSortList } from './sort';
import { useEffect } from 'react';
import { useCallback } from 'react';
import { MobileAdvancedFilters } from './mobile-filters';
import {
   expFiltersSelectExpCategoryEvent,
   expFiltersSelectGenderEvent,
   expFiltersSelectLocationEvent,
   expFiltersSelectPriceRangeEvent,
} from '~/utils/mixpanel-events/experience-filters';

interface AdvancedFiltersProps {
   regions: Region[];
   categories: FilterCategory[];
}
export const AdvancedFilters = ({ regions, categories }: AdvancedFiltersProps) => {
   const [showCategories, setShowCategories] = useState(false);
   const [showSheet, setShowSheet] = useState(false);
   const [showSort, setShowSort] = useState(false);

   const limit = showCategories ? categories.length : 8;

   const router = useRouter();

   const toggleShowCategories = () => setShowCategories(prev => !prev);

   const closeSheet = () => setShowSheet(false);
   const closeSorts = () => setShowSort(false);

   const closeAllSheets = useCallback(() => {
      showSort && closeSorts();
      showSheet && closeSheet();
   }, [showSheet, showSort]);

   Router.events.on('routeChangeStart', closeAllSheets);

   useEffect(() => {
      return () => Router.events.off('routeChangeStart', closeAllSheets);
   }, [closeAllSheets]);

   const onItemChange = (name: string, values: any) => {
      handleFilterItemChange(name, values, router);
      //tracking selected gender
      (name == 'females' || name == 'males') && values && expFiltersSelectGenderEvent(name);
      //tracking selected location
      name == 'location' && expFiltersSelectLocationEvent(values);
      //tracking selected price range
      name === 'price' && expFiltersSelectPriceRangeEvent(values[0], values[1]);
   };
   const onCategoryChange = (params: any) => {
      handleFilterCategoryChange(params, router);
      //tracking selected category
      params.type == 'category' && params.checked && expFiltersSelectExpCategoryEvent(params.name);
   };

   return (
      <div>
         <div className="hidden tablet:block">
            <div className="text-lg mb-7">
               <Translate id="filters:filters" />
            </div>
            {/* Desktop filters */}
            <AdvancedFiltersList
               toggleShowCategories={toggleShowCategories}
               showCategories={showCategories}
               limit={limit}
               categories={categories}
               regions={regions}
               onItemChange={onItemChange}
               onCategoryChange={onCategoryChange}
            />
         </div>

         <div className="block tablet:hidden">
            {/* Mobile Filters */}
            <MobileAdvancedFilters
               categories={categories}
               regions={regions}
               limit={limit}
               showCategories={showCategories}
               toggleShowCategories={toggleShowCategories}
               closeSheet={closeSheet}
               showSheet={showSheet}
            />

            <BottomSheet
               open={showSort}
               toggle={closeSorts}
               header={
                  <div className="flex">
                     <div className="flex-grow text-lg text-center ltr:ml-6 rtl:mr-6">
                        <Translate id="filters:sort" />
                     </div>
                     <button onClick={closeSorts}>
                        <CloseIcon />
                     </button>
                  </div>
               }>
               <div className="py-3 text-lg">
                  <BottomSheetSortList />
               </div>
            </BottomSheet>

            <div className="fixed inset-x-0 bottom-0 z-30 p-4 bg-gradient-to-b from-transparent to-[rgba(0,0,0,0.6)]">
               <div className="flex justify-center">
                  <button
                     className="bg-white w-[140px] py-2 ltr:rounded-l-default rtl:rounded-r-default font-bold"
                     onClick={() => setShowSheet(true)}>
                     <Translate id="filters:filters" />
                  </button>
                  <div className="flex items-center bg-white h-11">
                     <div className="w-[1px] h-6 bg-gray-300"></div>
                  </div>
                  <button
                     className="bg-white w-[140px] py-2 ltr:rounded-r-default rtl:rounded-l-default font-bold"
                     onClick={() => setShowSort(true)}>
                     <Translate id="filters:sort" />
                  </button>
               </div>
            </div>
         </div>
      </div>
   );
};
